import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { Icon, Input } from 'shared/ui';

interface TasksSearchProps {
    classes?: string[];
    onChange: (name: string, value: string) => void;
    value: string;
}

export const TasksSearch = memo(({ classes, value, onChange }: TasksSearchProps) => {
    const { t } = useTranslation();
    return (
        <Input
            onValueChange={onChange}
            value={value}
            name="search"
            classes={classes}
            placeholder={t('Features.TasksSearch.placeholder.text')}
            leftIcon={<Icon iconName="taskSearch" fill={value.length ? '#1094F7' : undefined} />}
        />
    );
});
